import { Avatar, Divider, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleClose } from 'Images';
import { ORDER_BY, OrderSort } from './OrderSort';
import { useContext, useState } from 'react';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';
import { useSupplierContext } from 'Hooks/useSupplierContext';
import { SuppliersContext } from 'Context/SuppliersContext';
import { SUPPLIERS_ID } from 'Enum/suppliers';
import { TherapyForm } from './TherapyForm';
import { DoctorForm } from './DoctorForm';

interface IAllFiltersForm {
  setOpenModal: Function;
}

export interface IForm extends IAllFiltersForm {
  selectedOrderBy: number;
}

export const AllFiltersForm = ({ setOpenModal }: IAllFiltersForm) => {
  const { suppliersId } = useContext(SuppliersContext);
  const { filters } = useSupplierContext();

  const [selectedOrderBy, setSelectedOrderBy] = useState<number>(
    filters.orderByAscendingAlphabet
      ? ORDER_BY.ASCENDING
      : filters.orderByDescendingAlphabet
      ? ORDER_BY.DESCENDING
      : 0
  );

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  const divider = isDesktop && (
    <Divider
      orientation='horizontal'
      sx={{ m: '16px 0', borderColor: '#E7EDFF' }}
    />
  );

  const getSupplierForm = () => {
    const props = { selectedOrderBy, setOpenModal };
    switch (suppliersId) {
      default:
      case SUPPLIERS_ID.mentalTherapy:
        return <TherapyForm {...props} />;
      case SUPPLIERS_ID.doctors:
        return <DoctorForm {...props} />;
    }
  };

  return (
    <Stack>
      <Stack
        sx={{
          position: 'sticky',
          top: 0,
          bgcolor: '#fff',
          zIndex: 2,
          pt: '32px',
        }}
      >
        <Avatar
          tabIndex={0}
          alt={dictionary.close}
          src={PurpleClose}
          sx={{
            position: 'sticky',
            top: '0px',
            right: undefined,
            left: '100vw',
            ':hover': {
              cursor: 'pointer',
            },
            width: isDesktop ? undefined : '32px',
            height: isDesktop ? undefined : '32px',
            zIndex: isDesktop ? undefined : '2',
          }}
          onClick={() => setOpenModal(false)}
          onKeyDown={onEnterOrEscapeKeyDown}
        />
        {isDesktop && (
          <Typography
            variant='body1'
            sx={{
              width: 'fit-content',
              fontSize: '28px !important',
              position: 'sticky',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          >
            {dictionary.allFilters}
          </Typography>
        )}
        {divider}
      </Stack>
      <OrderSort
        selectedOrderBy={selectedOrderBy}
        setSelectedOrderBy={setSelectedOrderBy}
      />
      {divider}
      {getSupplierForm()}
    </Stack>
  );
};
